import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Typography, List, ListItem, ListItemText } from '@mui/material';

const EnrollmentCompletedView = () => {
  const navigate = useNavigate();

  const handleFinish = () => {
    navigate("/");
  };

  const { t } = useTranslation('enrollment');

  const nextSteps = [
    "1. Confirm your eligibility and answer questions.",
    "2. Review the consent process.",
    "3. Schedule a convenient time for you to perform your voice-recording session."
  ];

  return (
    <div>
      <Typography variant="h4" component="h1" id="page-heading" tabIndex={-1}>
        {t("Registration Completed")}
      </Typography>
      <Typography variant="body1" sx={{ mt: 6 }}>
        {t("Thank you for your interest in becoming a Bridge2AI-Voice research participant and your invaluable support as we research voice as a biomarker of health. We are confirming that your registration has been received.")}
      </Typography>
      <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
        {t("What happens next?")}
      </Typography>
      <Typography variant="body1">
        {t("One of our research assistants will be reaching out to you in the upcoming week. At that time, the research assistant will email you to arrange a brief, secure video call. During that conversation they will:")}
      </Typography>
      <List sx={{ pl: 1 }}>
        {nextSteps.map((step, idx) => (
          <ListItem key={idx}>
            <ListItemText primary={t(step)} />
          </ListItem>
        ))}
      </List>
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("Until then, please feel free to email support@b2ai-voice.org if you have any immediate questions.")}
      </Typography>
      <Button variant="contained" onClick={handleFinish} sx={{ mt: 4, mb: 4 }}>
        {t("Finish")}
      </Button>
    </div>
  );
}

export default EnrollmentCompletedView;
